<template>
  <div class="d-flex flex-column align-items-center mt-1">
    Welcome to Assemble Sports
  </div>
</template>

<script>

export default {
  name: 'Home',
  mounted() {
    this.$router.push('dashboard');
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
.main-content {
  width: 100%;
}
</style>
